import {
  Component,
  EventEmitter,
  HostBinding,
  Injectable,
  Input,
  Output,
} from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { FormControl, Validators } from '@angular/forms';
import { HelperService } from 'src/services/helperService';
import { ResponseTimeSlots } from 'src/services/incadea/incadea-interfaces/responses/ResponseTimeSlots.interface';
import moment from 'moment';
import { GetTimeSlotsService } from 'src/services/incadea/incadea-services/getTimeSlots.service';
import { tap } from 'rxjs';
import { ResponseServices } from 'src/services/incadea/incadea-interfaces/responses/ResponseServices.interface';
import { ResponseResources } from 'src/services/incadea/incadea-interfaces/responses/ResponseResources.interface';

@Component({
    selector: 'app-i-calendar-web',
    templateUrl: './i-calendar-web.component.html',
    styleUrls: ['./i-calendar-web.component.sass'],
    standalone: false
})
@Injectable()
export class ICalendarWebComponent {
  // alternatively also the host parameter in the @Component()` decorator can be used
  @HostBinding('class.isDisabled') isDisabled: boolean = false;
  @Output() timeChanged: EventEmitter<string> = new EventEmitter();

  @Output() dateChanged: EventEmitter<string> = new EventEmitter();
  @Output() slotDurationChanged: EventEmitter<string> = new EventEmitter();
  timeSlotsIncadea: ResponseTimeSlots[] = [];
  LoadingHours: boolean = true;
  isLoadingCalendar: boolean = false;

  @Input() receivedTokenIncadea: string = '';
  @Input() receivedBackEndCode: string = '';
  @Input() receivedcompaniesSelect: any;
  @Input() receivedlocationSelect?: any;
  @Input() servicesSelect!: ResponseServices;
  @Input() resourcesSelect!: ResponseResources;

  public calendarTime: Date | null = null;
  calendarControl = new FormControl(null, Validators.required);
  otrasHoras: any;
  timeListButtons: any[] = [];
  isDateSelected: boolean = false;
  blockHours: any[] = [];
  rightArrow: HTMLButtonElement | null = null;
  leftArrow: HTMLButtonElement | null = null;
  calendarButton: HTMLButtonElement | null = null;
  selectedMonth: number = new Date().getMonth();
  calendarRange: { start: Date; end: Date } = {} as { start: Date; end: Date };
  slotDuration = 15;
  constructor(
    
    public helperService: HelperService,
    private translate: TranslateService,
    public getTimeSlotsService: GetTimeSlotsService
  ) {}
  ngOnInit(): void {
    this.GetTimeSlotsService();
  }

  SelectDateDinamic() {
    const moment = require('moment');
    this.timeListButtons = [];
    if(this.calendarTime){
    let dateonDDMMYY = moment(this.calendarTime).format('DD/MM/YYYY');
    this.dateChanged.emit(dateonDDMMYY);}
    this.isDateSelected = true;

    //Customize format of AM or PM in hour
    moment.updateLocale('en', {
      // Specify the callback function for
      // customizing the values
      meridiem: function (hour) {
        if (hour >= 12) return 'P.M';
        else return 'A.M';
      },
    });

    const filterDate = this.timeSlotsIncadea.filter(
      (slot) =>
        new Date(slot.From).toDateString() === this.calendarTime!.toDateString()
    );
    filterDate.forEach((hours) => {
      const formattedHour = hours.From.toString().split('T');
      this.timeListButtons.push({
        hours: moment(formattedHour[1], 'HH:mm:ss').format('hh:mm A'),
        class: 'btn-hour',
      });
    });
  }

  ngAfterViewInit() {
    this.calendarButton = document.querySelector(
      '.mat-focus-indicator.mat-calendar-period-button.mat-button.mat-button-base'
    ) as HTMLButtonElement;
    this.leftArrow = document.querySelector(
      '.mat-calendar-previous-button'
    ) as HTMLButtonElement;
    this.leftArrow!.addEventListener('click', () => {
      this.leftArrow!.style.display = 'none';
      this.rightArrow!.style.display = 'none';
      this.getCalendarRange(this.selectedMonth);
      this.selectedMonth--;
      this.calendarRange = this.getCalendarRange(this.selectedMonth);
      this.GetTimeSlotsService();
    });
    this.rightArrow = document.querySelector(
      '.mat-calendar-next-button'
    ) as HTMLButtonElement;
    this.rightArrow!.addEventListener('click', () => {
      this.rightArrow!.style.display = 'none';
      this.leftArrow!.style.display = 'none';
      this.getCalendarRange(this.selectedMonth);
      this.selectedMonth++;
      this.calendarRange = this.getCalendarRange(this.selectedMonth);
      this.GetTimeSlotsService();
    });
  }
  getCalendarRange(month: number): { start: Date; end: Date } {
    const fechaActual = new Date();
    const añoActual = fechaActual.getFullYear();
    const startMonth = new Date(añoActual, month, 1);
    const endMonth = new Date(añoActual, month + 1, 0, 24, 0, 0);
    return { start: startMonth, end: endMonth };
  }

  GetTimeSlotsService() {
    this.timeListButtons = [];
    this.LoadingHours = true;
    this.calendarRange = this.getCalendarRange(this.selectedMonth);
    this.timeListButtons = [];

    this.getTimeSlotsService
      .getTimeSlots(
        this.receivedTokenIncadea,
        this.receivedcompaniesSelect.Id,
        this.receivedlocationSelect.Id,
        this.calendarRange.start.toISOString(),
        this.calendarRange.end.toISOString(),
        [this.resourcesSelect.Id],
        [{ Id: this.servicesSelect.Id }],
        this.receivedBackEndCode
      )
      .pipe(
        tap((response: ResponseTimeSlots[]) => {
          // console.log(response)
          if (response.length > 0) {
            this.timeSlotsIncadea = response;
            const diferentInMinutes =
              (Number(new Date(this.timeSlotsIncadea[0].To)) -
                Number(new Date(this.timeSlotsIncadea[0].From))) /
              60000;
            this.slotDuration = diferentInMinutes;
            this.slotDurationChanged.emit(String(this.slotDuration));

            if (this.rightArrow && this.leftArrow) {
              this.rightArrow.style.display = 'inline-block';
              this.leftArrow.style.display = 'inline-block';
              this.calendarButton?.click();

              setTimeout(() => {
                // to click twice the change view button and reload calendar
                this.calendarButton?.click();
                this.timeListButtons = [];
                this.LoadingHours = false;
              }, 1);
            }
          } else {
            this.timeSlotsIncadea = [];
            this.LoadingHours = false;
            if (this.rightArrow && this.leftArrow) {
              this.rightArrow.style.display = 'inline-block';
              this.leftArrow.style.display = 'inline-block';
              this.calendarButton?.click();

              setTimeout(() => {
                // to click twice the change view button and reload calendar
                this.calendarButton?.click();
                this.timeListButtons = [];
                this.LoadingHours = false;
              }, 1);
            }
          }
        })
      )
      .subscribe();
  }

  daysForMonthNow(year, mounth, day) {
    var date = new Date(year + '/' + mounth + '/' + day);
    return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
  }

  hourButton: string = '';

  timeValue(e, index) {
    this.timeListButtons.forEach((name, i) => {
      name.class = 'btn-hour';
      if (i === index) {
        name.class = 'btn-hour-hover';
      }
    });

    this.hourButton = e.hours;
    this.timeChanged.emit(this.hourButton);
  }
  DateFilter = (date: Date | any) => {
    const today = new Date();
    let limitDate = new Date(
      new Date().getFullYear() +
        '-' +
        ('0' + (new Date().getMonth() + 6)).slice(-2) +
        '-' +
        this.daysForMonthNow(
          new Date().getFullYear(),
          new Date().getMonth() + 6,
          '01'
        ) +
        'T23:59'
    );
    if (new Date().getMonth() + 7 > 12) {
      limitDate = new Date(
        new Date().getFullYear() +
          1 +
          '-' +
          ('0' + (new Date().getMonth() + 7 - 12)).slice(-2) +
          '-' +
          this.daysForMonthNow(
            new Date().getFullYear() + 1,
            new Date().getMonth() + 7 - 12,
            '01'
          ) +
          'T23:59'
      );
    }
    const limitDatenumber = limitDate.getTime();


    return (
      date >= today &&
      date <= limitDatenumber &&
      this.timeSlotsIncadea.filter(
        (s) => new Date(s.To).toDateString() === date.toDateString()
      ).length > 0
    );
  };
}
